import { Injectable } from '@angular/core';
import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { IssueNameErrors } from '../enums/issue-name-errors';

@Injectable({
  providedIn: 'root',
})
export class CustomValidatorsService {
  onCheckUniqueString(strings: string[]): ValidatorFn {
    return (control: AbstractControl) => {
      const isNewCustomMapNameUnique = !strings.includes(control.value.toLowerCase().trim());
      return isNewCustomMapNameUnique ? null : { notUnique: true };
    };
  }

  digitsMaxLength(maxLength: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      return control.value && String(control.value).length <= maxLength ? null : { maxLength };
    }
  }

  dependentIssueDisplayNameRequired(): ValidatorFn {
    return (form: FormGroup): ValidationErrors | null => {
      const issueDisplayNameControl = form.get('IssueDisplayName');
      const issueDisplayNamePluralControl = form.get('IssueDisplayNamePlural');

      if (!issueDisplayNameControl.value && issueDisplayNamePluralControl.value) {
        const issueSingularNameRequiredError = { [IssueNameErrors.IssueSingularNameRequired]: true };
        issueDisplayNameControl.setErrors(issueSingularNameRequiredError);

        return issueSingularNameRequiredError;
      }

      if (issueDisplayNameControl.value && !issueDisplayNamePluralControl.value) {
        const issuePluralNameRequiredError = { [IssueNameErrors.IssuePluralNameRequired]: true };
        issueDisplayNamePluralControl.setErrors(issuePluralNameRequiredError);

        return issuePluralNameRequiredError;
      }

      issueDisplayNameControl.setErrors(null);
      issueDisplayNamePluralControl.setErrors(null);

      return null;
    };
  }
}
